import React, { useState } from 'react';
import { HiOutlineLightBulb, HiOutlineCheckCircle } from 'react-icons/hi';
import { toast } from 'react-toastify';

function StickerSuggestion() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    category: '',
    description: '',
    style: 'minimalista'
  });
  const [submitted, setSubmitted] = useState(false);
  
  const categories = [
    'Bom Dia',
    'Boa Noite',
    'Boa Tarde',
    'Férias',
    'Maternidade',
    'Afiliadas',
    'Dias da Semana',
    'Pet',
    'Café',
    'Frases',
    'Academia',
    'Clima',
    'Lar e Rotina',
    'Fé e Espiritualidade',
    'Auto Cuidado',
    'Comida',
    'Home Office',
    'Outra'
  ];
  
  const styles = [
    { value: 'minimalista', label: 'Minimalista' },
    { value: 'colorido', label: 'Colorido' },
    { value: 'elegante', label: 'Elegante' },
    { value: 'fofinho', label: 'Fofinho' },
    { value: 'profissional', label: 'Profissional' }
  ];
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validação básica
    if (!formData.name || !formData.email || !formData.description) {
      toast.error('Por favor, preencha todos os campos obrigatórios.');
      return;
    }
    
    // Simular envio
    try {
      // Em produção, aqui seria uma chamada à API
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setSubmitted(true);
      toast.success('Sugestão enviada com sucesso!');
    } catch (error) {
      toast.error('Erro ao enviar sugestão. Tente novamente.');
    }
  };
  
  const handleReset = () => {
    setFormData({
      name: '',
      email: '',
      category: '',
      description: '',
      style: 'minimalista'
    });
    setSubmitted(false);
  };
  
  if (submitted) {
    return (
      <div className="suggestion-page">
        <div className="empty-state" style={{ paddingTop: '100px' }}>
          <div className="empty-state-icon" style={{ color: 'var(--color-accent-green)' }}>
            <HiOutlineCheckCircle />
          </div>
          <h3 className="empty-state-title">Obrigado pela sua sugestão!</h3>
          <p className="empty-state-text">
            Recebemos sua sugestão de sticker. Nossa equipe irá analisá-la e, 
            se aprovada, ela será adicionada à nossa biblioteca em breve.
          </p>
          <button 
            className="btn btn-primary" 
            onClick={handleReset}
            style={{ marginTop: '24px' }}
          >
            Enviar outra sugestão
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="suggestion-page">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">
          <HiOutlineLightBulb style={{ marginRight: '12px', verticalAlign: 'middle' }} />
          Sugestão de figurinha
        </h1>
        <p className="page-subtitle">
          Tem uma ideia de sticker? Sugira e nós criamos para você!
        </p>
      </div>
      
      {/* Form */}
      <div className="suggestion-form">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Seu nome *</label>
            <input
              type="text"
              name="name"
              className="form-input"
              placeholder="Digite seu nome"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Seu email *</label>
            <input
              type="email"
              name="email"
              className="form-input"
              placeholder="Digite seu email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Categoria</label>
            <select
              name="category"
              className="form-select"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="">Selecione uma categoria</option>
              {categories.map((cat) => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label className="form-label">Estilo desejado</label>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              {styles.map((style) => (
                <label 
                  key={style.value}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    border: `2px solid ${formData.style === style.value ? 'var(--color-primary)' : 'var(--color-border)'}`,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    backgroundColor: formData.style === style.value ? 'var(--color-bg-card-hover)' : 'transparent'
                  }}
                >
                  <input
                    type="radio"
                    name="style"
                    value={style.value}
                    checked={formData.style === style.value}
                    onChange={handleChange}
                    style={{ display: 'none' }}
                  />
                  <span>{style.label}</span>
                </label>
              ))}
            </div>
          </div>
          
          <div className="form-group">
            <label className="form-label">Descreva sua ideia *</label>
            <textarea
              name="description"
              className="form-textarea"
              placeholder="Descreva detalhadamente como você imagina o sticker..."
              value={formData.description}
              onChange={handleChange}
              required
            />
          </div>
          
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
            <HiOutlineLightBulb />
            Enviar Sugestão
          </button>
        </form>
      </div>
    </div>
  );
}

export default StickerSuggestion;
